import { FontIcon } from '../FontIcon';
import styles from './lock.module.sass';
import cn from 'classnames';

interface LockProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
    filled?: boolean;
    inline?: boolean;
    small?: boolean;
    relative?: boolean;
    program?: boolean;
}

export const Lock = ({ filled, inline, small, program, className, relative, ...props }: LockProps) => {
    const LockClasses = cn(
        styles.lock,
        relative && styles.lockRelative,
        filled && styles.filled,
        inline && styles.inline,
        small && styles.small,
        program && styles.program,
        className
    );

    return (
        <div className={LockClasses} {...props}>
            <FontIcon name="lock" size="smaller" md="small" />
        </div>
    );
};
